import { render, staticRenderFns } from "./DetectionFeedback.vue?vue&type=template&id=18857f78&scoped=true"
import script from "./DetectionFeedback.vue?vue&type=script&lang=ts"
export * from "./DetectionFeedback.vue?vue&type=script&lang=ts"
import style0 from "./DetectionFeedback.vue?vue&type=style&index=0&id=18857f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18857f78",
  null
  
)

export default component.exports